(function () {

    angular
        .module('smartertoolsApp')
        .service('licenseKeyService', ['$http', 'refreshToken', 'cacheControl', '$q', licenseKeyService]);

    function licenseKeyService($http, refreshToken, cacheControl, $q) {
        var getAllPromise;
        var vm = this;
        vm.urlBase = apiRootUrl;

        // Functions
        vm.getLicenses = getLicenses;
        vm.resetActivations = resetActivations;
        vm.getLicensesSupport = getLicensesSupport;
        vm.clearCache = clearCache;

        activate();

        // -----------------------------------------------

        function activate() {
        }

        function clearCache() {
            cacheControl.getCache('licensesAllCache').removeAll();
        }
        
        function getLicenses() {
            //if (getAllPromise)
            //	return getAllPromise;
            getAllPromise = refreshToken.refreshToken()
                .then(() => $http.get(vm.urlBase + 'v1/account/licenses/all', {cache: cacheControl.getCache('licensesAllCache')}))
                .then((response) => {
                    getAllPromise = null;
                    response.data.Licenses = response.data.Licenses || [];
                    for (let i = 0; i < response.data.Licenses.length; i++) {
                        const item = response.data.Licenses[i];
                        item._isExpired = isExpired(item.UpgradeProtectionExpiresUtc);
                        item._isExpiringSoon = isExpiringSoon(item.UpgradeProtectionExpiresUtc);
                        item._isExpiringVerySoon = isExpiringVerySoon(item.UpgradeProtectionExpiresUtc);
                        item._upgradeProtectionCategory = '';
                        if (item._isExpiringSoon)
                            item._upgradeProtectionCategory = 'expiring-soon';
                        else if (item._isExpired)
                            item._upgradeProtectionCategory = 'expired';
                        else 
                            item._upgradeProtectionCategory = 'active';
                    }
                    return response.data;
                })
                .catch((err) => {
                    getAllPromise = null;
                    $q.reject(err);
                });
            return getAllPromise;
        };

        function isExpired(expires) {
            return new Date(expires) < Date.now();
        }

        function isExpiringSoon(expires) {
            let soon = new Date();
            soon.setDate(soon.getDate() + 60);
            return !isExpired(expires) && (new Date(expires) < soon);
        }

        function isExpiringVerySoon(expires) {
            let soon = new Date();
            soon.setDate(soon.getDate() + 15);
            return !isExpired(expires) && (new Date(expires) < soon);
        }

        function getLicensesSupport() {
            getAllPromise = refreshToken.refreshToken()
                .then(() => $http.get(vm.urlBase + 'v1/account/licenses/all-support'))
                .then((response) => {
                    getAllPromise = null;
                    return response.data;
                })
                .catch((err) => {
                    getAllPromise = null;
                    $q.reject(err);
                });
            return getAllPromise;
        }

        function resetActivations(licenseKey, reason) {
            return refreshToken.refreshToken()
                .then(() => $http.post(vm.urlBase + 'v1/account/licenses/reset-activations',
                    JSON.stringify({LicenseKeyString: licenseKey, Reason: reason})))
                .then((response) => response.data);
        };
    }

})();